// removed by extract-text-webpack-plugin
module.exports = {"PlayerOverlay":"Q13-MzN5tAamaRXRNuHHP","animateIn":"_15Nz1WGa78-wp5OCcM0TWq","animateOut":"_2rzabHk_5PauDL8wEjCDM0","closePlayerOverlay":"_1lxSR9TDmFo-k7InhcQNG","category":"_2JckFTYkJiCY2H2GB7GHEI","title":"_2wgZWKQGOvh6TU0v8ePUbA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AudioGuideComponents/AudioGuidePlayer/AudioGuidePlayer.css
// module id = 501
// module chunks = 8